






















































































































import Vue from 'vue'
import mixin from './cardmixin.vue'

import { IotStatisticServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import dayjs from "dayjs";
const iotStatisticProxy = new IotStatisticServiceProxy()
const customerProxy = new CustomerServiceProxy();

export default Vue.extend({
  name: 'gateway-statue-record-card',
  mixins: [mixin],
  data() {
    return {
      color: [
        '#73D13D',
        '#D8D8D8',
        '#FA554C',
        '#84A5FE',
        '#D3AEF8',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
      ],
      data: [],
      onlineState: '1',
      badgeStatus: [],
      myChart: null,
      echartData: [],
      loading: false,
      customers: [],
      customerId: '',
    }
  },
  mounted() {
    this.getList()
    this.initCustomerList();
  },
  watch: {
    chartOption: {
      handler(val) {
        if (this.myChart) {
          this.myChart.setOption(val, true)
        }
      },
      deep: true
    },
  },
  methods: {
    initCustomerList(){
      customerProxy.getCustomers('', '')
        .then(res=>{
          this.customers  = res;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getList() {
      this.loading=true;
      iotStatisticProxy.gatewayStatusRecord(this.customerId,this.onlineState||"1")
      .then(res=>{
        this.data=res.list;
        this.echartData=[
          {name:'当前在线', value: res.onlineNumber, show: true},
          {name:'离线', value: res.total-res.onlineNumber, show: true},
        ];
        this.$nextTick().then(()=>{
          this.myChart = this.$echarts.init(this.$refs.myChart)
          this.myChart.setOption(this.chartOption)
        });
      })
      .finally(()=>{
        this.loading=false;
      });
    },
    onlineStateChange() {
      this.getList();
    },
    chartLabel(){
      if(this.onlineState==='2'){
        return this.$t('page_online_now')
      }
      if(this.onlineState==='3'){
        return this.$t('page_online_day')
      }
      if(this.onlineState==='4'){
        return this.$t('page_online_7')
      }
      if(this.onlineState==='5'){
        return this.$t('page_online_30')
      }
      if(this.onlineState==='6'){
        return this.$t('not_online_week')
      }
      if(this.onlineState==='7'){
        return this.$t('not_online_month')
      }
      if(this.onlineState==='8'){
        return this.$t('not_online_3month')
      }

      return this.$t('page_tpm_repair_all')
    },
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('gateway_code'),
          key: 'gatewayCode',
          dataIndex: 'gatewayCode',
          ellipsis: true
        },
        {
          title: this.$t('page_resource_pool_status'),
          key: 'isOnline',
          dataIndex: 'isOnline',
          ellipsis: true,
          scopedSlots: { customRender: 'isOnline' },
        },
        {
          title: this.$t('last_online'),
          key: 'lastOnlineTime',
          dataIndex: 'lastOnlineTime',
          ellipsis: true,
          customRender: (time) => time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : ''
        },
        {
          title: this.$t('page_ops_customer_customer_name'),
          key: 'customer',
          dataIndex: 'customer',
          ellipsis: true,
           scopedSlots: { customRender: 'customer' }
        }
      ]
    },
    chartOption() {
      let title = this.chartLabel();// '网关总和'

      let formatNumber = function(num) {
        let reg = /(?=(\B)(\d{3})+$)/g
        return num.toString().replace(reg, ',')
      }
      let total = this.echartData.reduce((a, b) => {
        return a + b.value * 1
      }, 0)

      let option = {
        color: this.color,
        title: [
          {
            text: '{val|' + formatNumber(total) + '}\n{name|' + title + '}',
            top: 'center',
            left: 'center',
            textStyle: {
              rich: {
                align: 'canter',
                name: {
                  fontSize: 16,
                  fontWeight: 'bold',
                  color: '#666666',
                  padding: [10, 0]
                },
                val: {
                  fontSize: 18,
                  fontWeight: 'bold',
                  color: '#5396E3'
                }
              }
            }
          }
        ],
        series: [
          {
            type: 'pie',
            radius: ['60%', '85%'],
            center: ['50%', '50%'],
            data: this.echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderWidth: 2
              }
            },
            labelLine: {
              normal: {
                length: 20,
                length2: 120,
                lineStyle: {
                  color: '#e6e6e6'
                }
              }
            },
            label: {
              show: false
            }
          }
        ]
      }
      return option
    }
  },
})
